import { render, staticRenderFns } from "./scrap.vue?vue&type=template&id=136d3466&scoped=true"
import script from "./scrap.vue?vue&type=script&lang=js"
export * from "./scrap.vue?vue&type=script&lang=js"
import style0 from "./scrap.vue?vue&type=style&index=0&id=136d3466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136d3466",
  null
  
)

export default component.exports